define("shared/utils/plans-data/feature-keys", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  //Note: featureKeys is a dictionary used to map items on the features Object within a subscription plan
  //where the key is what is used on the FE and the value is the key received from the BE
  const featureKeys = {
    analyticsExport: 'analytics_export',
    analyticsReport: 'analytics_performance_report',
    analyticsStandard: 'analytics_standard',
    bttp: 'bttp',
    calendarNotes: 'calendar_notes',
    chromeExtension: 'chrome_extension',
    contributors: 'contributors',
    conversations: 'conversations',
    filters: 'filters',
    firstComment: 'first_comment',
    accessGroups: 'groups',
    hashtagAnalytics: 'hashtag_analytics',
    hashtagTrends: 'hashtag_trends',
    locationTagging: 'location_tagging',
    linkinbioButtonColor: 'linkinbio_button_colour',
    linkinbioEmbeddable: 'linkinbio_embeddable',
    linkinbioFeaturedMediaImage: 'linkinbio_featured_media_image',
    linkinbioFeaturedMediaVideo: 'linkinbio_featured_media_embedded_video',
    linkinbioLinkedSocialPosts: 'linkinbio_many_linked_social_posts',
    linkinbioStandard: 'linkinbio_standard',
    mentionedMedia: 'collect_mentions',
    multiPhoto: 'multi_photo',
    multiProfileScheduling: 'multi_profile_scheduling',
    photos: 'photos',
    pinAnalytics: 'pinterest_analytics',
    pinterestClickTracking: 'pinterest_click_tracking',
    igProductTagging: 'ig_product_tagging',
    savedCaptions: 'saved_captions',
    searchByHashtag: 'collect_hashtags',
    searchByProfile: 'search_by_ig_profile',
    shareCalendar: 'schedule_sharing',
    stockPhoto: 'stock_photo',
    stories: 'ig_stories_scheduling',
    supportDocs: 'support_docs',
    supportEmail: 'support_email',
    supportMessaging: 'support_messaging',
    taggedMedia: 'collect_tags',
    tagging: 'user_location_tagging',
    textOnImages: 'text_on_image',
    tiktok: 'tiktok',
    twAnalytics: 'twitter_analytics',
    twitterClickTracking: 'twitter_click_tracking',
    unlimitedMedia: 'unlimited_media',
    userTagging: 'user_tagging',
    videoCoverSelect: 'video_cover_select',
    videos: 'video',
    visualPlanner: 'visual_planner'
  };
  var _default = featureKeys;
  _exports.default = _default;
});